module.exports = __webpack_public_path__ + "static/media/gallery-14.b1c77902.jpg";